import React from "react"
import RyderLivescoringTeam from "@/components/RyderLivescoring/RyderLivescoringTeam"
import RyderLivescoringHoles from "@/components/RyderLivescoring/RyderLivescoringHoles"

const RyderLivescoringMatchCardDefaultView = ({
    leftWon,
    rightWon,
    matchDate,
    matchHour,
    leftPlayers,
    leftIdNum,
    tbdLeft,
    leftSide,
    rightPlayers,
    rightIdNum,
    tbdRight,
    rightSide,
    colors,
    match,
    isDraw,
    holes,
    teamColors,
    customDesign
}) => {
    return (
        <div
            className={`relative rounded-lg bg-white shadow-sm mb-2 overflow-hidden border-0 ` +
                (leftWon
                    ? `border-b-3 border-b-${colors[0]}-500`
                    : rightWon
                        ? `border-b-3 border-b-${colors[1]}-500`
                        : `border-b border-gray-200`
                )}
        >
            <div className="sm:hidden bg-gray-50 px-4 py-2 flex justify-end items-center text-xs sm:text-sm font-medium text-gray-700 border-b border-gray-300">
                <span className="text-xs sm:text-xs lg:text-base font-medium text-gray-700 date-style bg-gray-100 rounded-md px-2 py-1">
                    {matchDate}
                </span>
                {matchHour && (
                    <span className="text-xs sm:text-xs lg:text-base font-medium text-gray-700 hour-style bg-blue-100 rounded-full px-2 py-1">
                        {matchHour}
                    </span>
                )}
            </div>

            <div className="flex flex-col sm:flex-row">
                <RyderLivescoringTeam
                    players={leftPlayers}
                    teamColor={teamColors[leftIdNum]}
                    isWinner={leftWon}
                    isDraw={isDraw}
                    result={match.result}
                    match={match}
                    tbd={tbdLeft}
                    side={leftSide}
                    customDesign={customDesign}
                />
                <RyderLivescoringTeam
                    players={rightPlayers}
                    teamColor={teamColors[rightIdNum]}
                    isWinner={rightWon}
                    isDraw={isDraw}
                    result={match.result}
                    tbd={tbdRight}
                    match={match}
                    isRight={true}
                    side={rightSide}
                    customDesign={customDesign}
                />
            </div>

            <RyderLivescoringHoles
                holes={holes}
                team1Id={leftIdNum}
                team2Id={rightIdNum}
                teamColors={teamColors}
                match={match}
                customDesign={customDesign}
            />
        </div>
    )
}

export default RyderLivescoringMatchCardDefaultView
